import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';

// component
import CommonModal from "../../modal/CommonModal";
import CommonPagination from "../../pagination/CommonPagination";

// api
import { getMessageFromMomthera } from "../../../services/apis/momthera/message";

function MomtheraMessage() {
    const { pid } = useParams();
    const [messageData, setMessageData] = useState([]);

    const [searchInput, setSearchInput] = useState("");
    const [searchDate, setSearchDate] = useState({
        start: `${new Date().getFullYear()-1}-${(new Date().getMonth()+1).toString().padStart(2,'0')}-${new Date().getDate().toString().padStart(2,'0')}`,
        end: `${new Date().getFullYear()}-${(new Date().getMonth()+1).toString().padStart(2,'0')}-${new Date().getDate().toString().padStart(2,'0')}`
    })

    const [requestOption, setRequestOption] = useState({
        text: "",
        start: `${new Date().getFullYear()-1}-${(new Date().getMonth()+1).toString().padStart(2,'0')}-${new Date().getDate().toString().padStart(2,'0')}`,
        end: `${new Date().getFullYear()}-${(new Date().getMonth()+1).toString().padStart(2,'0')}-${new Date().getDate().toString().padStart(2,'0')}`
    })

    // pagination
    const [totalDataCnt, setTotalDataCnt] = useState(0);
    const [selectedPage, setSelectedPage] = useState(1);


    // 메시지 더보기 모달
    const [showOpenMessageModal, setShowOpenMessageModal] = useState(false);
    const [message, setMessage] = useState(null);

    const handleClickOpenMessageBtn = (item) => {
        setMessage(item);
        setShowOpenMessageModal(true);
    }

    const closeOpenMessageModal = () => {
        setShowOpenMessageModal(false);
    }

    const OpenMessageModalBody = (
		<div className="modalbody" style={{height: '30rem'}}>
			<div className="formModalItem" style={{flexDirection: 'column', height: '100%'}}>
				<div className="momthera_sendMessageModalBody_label">내용</div>
				<div className="momthera_sendMessageModalBody_input" style={{flexGrow: 1}}>
					<textarea
						type="text"
						className="formModalItem__input__textarea"
						placeholder="내용을 입력해주세요."
						value={message ? message.contents : ""}
						style={{ height: '100%', width: '100%' }}
                        readOnly
					/>
				</div>
			</div>
		</div>
	)


    function convertDate(date) {
        if(!date) return "";

        return date.split('-').join('');
    }

    async function getMessageFromAPI() {
        try {
            const request = {
                pid,
                start: convertDate(requestOption.start),
                end: convertDate(requestOption.end),
                text: requestOption.text,
                page: selectedPage
            }
            const res = await getMessageFromMomthera(request);
            if(parseInt(res.status/200,10)===1 && res.data.length>0){
                setMessageData(res.data);
                setTotalDataCnt(res.data[0].totalCnt);
            }else{
                throw new Error();
            }
        }catch(err){
            setMessageData([]);
            setTotalDataCnt(0);
        }
    }

    function handleSearchText() {
        setRequestOption({
            ...requestOption,
            text: searchInput.trim()
        })
    }

    function handleSearchDate() {
        setRequestOption({
            ...requestOption,
            start: searchDate.start,
            end: searchDate.end
        })
    }

    function printDate(date) {
        const dayList = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
        const dateArr = date.split(' ');
        const day = dayList[new Date(dateArr[0]).getDay()];
        return `${dateArr[0]}. ${day}${"\u00A0"}${"\u00A0"}${dateArr[1]}`;
    }

    const getNewDataByPagination = (page) => {
        setSelectedPage(page)
    }


    useEffect(()=>{
        getMessageFromAPI();
    },[requestOption, selectedPage])

    return (
        <div className="patientResult__message momthera" style={{height: 'auto', gap: '0.3125rem'}}>
            <div className="message_row1" style={{height: 'auto', padding: '1.25rem 2rem'}}>
                <div className="search_input_wrapper">
                    <div className="search_input_label">검색</div>
                    <div className="search_input">
                        <input
                            type="text"
                            placeholder="내용을 입력해주세요"
                            value={searchInput}
                            onChange={e=>setSearchInput(e.target.value)}
                        />
                    </div>
                    <div className="header_button_wrapper">
                        <button
                            type="button"
                            onClick={handleSearchText}
                        >검색</button>
                        <button
                            type="button"
                            onClick={()=>setSearchInput("")}
                        >초기화</button>
                    </div>
                </div>
            </div>
            <div className="message_row2" style={{display: 'flex', flexDirection: 'column', padding: '0.625rem 0', height: 'auto'}}>
                <div className="row2_header">
                    <input
                        type="date"
                        value={searchDate.start}
                        onChange={e=>setSearchDate({
                            ...searchDate,
                            start: e.target.value
                        })}
                    />
                    <p className="date_bar">ㅡ</p>
                    <input
                        type="date"
                        value={searchDate.end}
                        onChange={e=>setSearchDate({
                            ...searchDate,
                            end: e.target.value
                        })}
                    />
                    <button
                        className="message_search_button"
                        type="button"
                        onClick={handleSearchDate}
                    >조회</button>
                </div>
                <div className="message_box_list" style={{height: 'auto', flexGrow: 1}}>
                    {messageData.length>0 && messageData.map((item, idx)=> (
                        <div key={idx} className="message_box momthera_message_box">
                            <div className="momthera_message_box_contentWrapper">
                                <div className="message_box_header">
                                    <div className={`message_box_type ${item.noticeType==="private" ? 'private' : ""}`}>{item.noticeType==="private" ? "개인 메시지" : "단체 메시지"}</div>
                                    <div className="message_box_date">{printDate(item.receiptDate)}</div>
                                </div>
                                <div className="message_box_content">
                                    {item.contents}
                                </div>
                            </div>
                            <button
                                className="momthera_message_box_openBtn"
                                onClick={()=>handleClickOpenMessageBtn(item)}
                            >+ 더보기</button>
                        </div>
                    ))}                    
                </div>
                <CommonPagination
                    pageCnt={Math.ceil(totalDataCnt/4) || 1}
                    selectedPage={selectedPage}
                    SetSelectedPage={setSelectedPage}
                    GetNewTableData={getNewDataByPagination}
                />
            </div>
            <CommonModal
				header="메시지 상세보기"
				body={OpenMessageModalBody}
				show={showOpenMessageModal}
				setClose={closeOpenMessageModal}
				size="lg"
			/>
        </div>
    );
}

export default MomtheraMessage;